import { render } from "./InstantMeetingView.vue?vue&type=template&id=3730f8a8"
import script from "./InstantMeetingView.vue?vue&type=script&lang=js"
export * from "./InstantMeetingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__